import { Box, useMediaQuery } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import Mobile from './mobile'
import Desktop from './desktop'
import { selectNotification } from '../../../../redux/features/notifications/notificationCenter/notificationCenterSlice'
import {
  filterNotificationsCenterList,
} from '../../../../redux/features/notifications/notificationCenter/notificationCenterThunk'

const PageFilter = ({ openModal, setOpenModal }) => {
  const dispatch = useDispatch()
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const notificationStore = useSelector(selectNotification)

  const [headers, setHeaders] = useState([])
  const [date, setDate] = useState([])

  useEffect(() => {
    if (notificationStore?.activeFilters?.headers?.length !== headers.length) {
      setHeaders(notificationStore?.activeFilters?.headers || [])
    }
    if (notificationStore?.activeFilters?.date?.length !== date.length) {
      setDate(notificationStore?.activeFilters?.date || [])
    }
  }, [notificationStore?.activeFilters])

  useEffect(() => {
    if ((openModal)) {
      dispatch(filterNotificationsCenterList({
        queries: {
          headers,
          date,
        },
      }))
    }
  }, [date, headers])

  return (
    <Box>
      {isXsScreen ? (
        <Mobile
          openModal={openModal}
          setOpenModal={setOpenModal}
          headers={headers}
          setHeaders={setHeaders}
          date={date}
          setDate={setDate}
        />
      ) : (
        <Desktop
          openModal={openModal}
          setOpenModal={setOpenModal}
          headers={headers}
          setHeaders={setHeaders}
          date={date}
          setDate={setDate}
        />
      )}
    </Box>
  )
}

export default PageFilter
